import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';

export class INVOCATION_IMAGE__sharp extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__SHARP;

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    { graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE, field_role: 'Image to Sharp' },
  )
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 5.0,
      value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_50,
      values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_50,
      //
      slider_step: 25,
      slider_step_values: [5, 10, 25],
    },
    { field_role: 'Unsharp mask radius' },
  )
  radius!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 16,
      value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_1024,
      values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_1024,
      //
      slider_step: 16,
      slider_step_values: [16, 32, 64, 128, 256, 512],
    },
    { field_role: 'Unsharp mask strength' },
  )
  strength!: FIELD_PRIMITIVE__float;

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out!: FIELD__image_asset;

  /*
   *
   */
  constructor() {
    super(ENUM__invocation_type.IMAGE__SHARP);
  }

  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.strength.find_source(graph).get_value() == 0) return false;
    if (this.radius.find_source(graph).get_value() == 0) return false;

    return super.has_effect_on_generation_runtime(graph);
  }
}
